import React, { useRef } from 'react';
import {
  AccordionItem as ReactAccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion';
import { v4 as uuidv4 } from 'uuid';

import { StyledAccordion, Title } from './AccordionItem.styles';

import { AccordionItemProps } from './AccordionItem.types';

import { AccordionToggle } from './AccordionToggle';

const AccordionItem = ({
  uuid,
  title,
  titleTag = 'div',
  content,
  handleItemRefExpansion,
  componentClassname,
  ...props
}: AccordionItemProps) => {
  const itemRef = useRef(null);

  return (
    <StyledAccordion className={`${componentClassname}__item`} {...props}>
      <ReactAccordionItem uuid={uuid ?? uuidv4()}>
        <AccordionItemState>
          {(state) => {
            if (state.expanded) {
              handleItemRefExpansion(itemRef);
            }
            return (
              <div ref={itemRef}>
                <AccordionItemHeading
                  className={`${componentClassname}__item-heading ${componentClassname}__item-heading--${
                    state.expanded ? 'expanded' : 'closed'
                  }`}
                >
                  <AccordionItemButton
                    className={`${componentClassname}__button`}
                  >
                    <Title
                      as={titleTag}
                      className={`${componentClassname}__title`}
                    >
                      {title}
                    </Title>
                    <div className={`${componentClassname}__toggle-container`}>
                      <AccordionToggle
                        isExpanded={!!state.expanded}
                        componentClassname={`${componentClassname}__toggle`}
                      />
                    </div>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel
                  className={`${componentClassname}__content ${componentClassname}__content--${
                    state.expanded ? 'expanded' : 'closed'
                  }`}
                >
                  {content}
                </AccordionItemPanel>
              </div>
            );
          }}
        </AccordionItemState>
      </ReactAccordionItem>
    </StyledAccordion>
  );
};
AccordionItem.displayName = 'AccordionItem';

export default AccordionItem;
